import React from 'react';

import Button from '@atlaskit/button';

import { StorageOfUniqueServices } from '@qality/common-service';

import { ContainerStyled } from './EnableAttachments.styled';

export default function EnableAttachments(): JSX.Element {
  return (
    <ContainerStyled>
      <Button
        appearance='subtle-link'
        onClick={() => {
          window.open(
            StorageOfUniqueServices.get(
              'URLService'
            ).getViewAttachmentSettingsUrl(),
            '_blank'
          );
        }}
      >
        Enable
      </Button>
    </ContainerStyled>
  );
}
